import getDefaultColorSchemeLabels from './get-default-color-scheme-labels';

const getSurfaceName = (surfaceId, schemes = {}) => {
  const entry = getDefaultColorSchemeLabels().find(([id]) => id === surfaceId);
  return entry ? entry[1] : schemes[surfaceId]?.name;
};

export default getSurfaceName;
